import { render, staticRenderFns } from "./CrewSearch.vue?vue&type=template&id=2447b3cf&scoped=true&"
import script from "./CrewSearch.vue?vue&type=script&lang=ts&"
export * from "./CrewSearch.vue?vue&type=script&lang=ts&"
import style0 from "./CrewSearch.vue?vue&type=style&index=0&id=2447b3cf&prod&lang=scss&scoped=true&"
import style1 from "./CrewSearch.vue?vue&type=style&index=1&id=2447b3cf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2447b3cf",
  null
  
)

export default component.exports